module.exports = __webpack_public_path__ + "static/media/guide3.ed5f2021.png";